import "../../App.css";
import "./V2.css";
import NavBar from '../../components/Navbar'
import SoldInfoBox from './components/SoldInfo';
import TotalInfoBox from './components/TotalInfo';
import { Container, Row, Col } from 'react-bootstrap';
import SpaceBackground from '../../assets/Background.png';
import CardWall from './components/cardWalls'
import SoldInfoFrame from './components/SoldInfoFrame.tsx';
import NewestFrame from './components/NewestFrame.tsx';
import Newest from '../card/walls/newest.js'
import Pokemon from '../dashboard/components/pokemon.js'
import Submission from '../submission/submissionsDash-v2.tsx';
import Sold from '../dashboard/sold/soldTable.tsx'


function Dashboard() {
    return (
        <div
            className="v2-background min-vh-100 w-100"
            style={{
                backgroundImage: `url(${SpaceBackground})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '1500px auto',
                backgroundAttachment: 'fixed',
            }}
        >
            <NavBar />
            <div className='reports'>
                <Container fluid='xl'>
                    <Row className="v2NavSpacer"></Row>
                    <Row className="aligned-row d-flex justify-content-center justify-content-lg-between align-items-start g-0">
                        <Col xs="auto" lg="auto" className="d-flex justify-content-center mb-3 mb-lg-0">
                            <SoldInfoFrame>
                                <h5 className="frame-title frame-title--red">SOLD INFO</h5>
                                <SoldInfoBox />
                            </SoldInfoFrame>
                        </Col>
                        <Col xs="auto" lg="auto" className="d-flex justify-content-center">
                            <SoldInfoFrame>
                                <h5 className="frame-title frame-title--red">INVENTORY</h5>
                                <TotalInfoBox />
                            </SoldInfoFrame>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center">
                        <Col xs="12" className="d-flex justify-content-center">
                            <NewestFrame>
                                <h5 className="frame-title frame-title--red">NEWEST CARDS</h5>
                                <div className="newest-row"><Newest /></div>
                                <div className="newest-row"><Pokemon /></div>
                            </NewestFrame>
                        </Col>
                    </Row>
                    <Row className='d-flex justify-content-center'>
                        <CardWall />
                    </Row>
                    <Row className='d-flex justify-content-center'>
                        <Col xl={4} md={5}>
                            <Submission />
                        </Col>
                        <Col xl={8} lg={7} md={7}>
                            <Sold />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default Dashboard;
